module.exports = __webpack_public_path__ + "img/boat3.3825dc93.png";